/**
 * 模組頁面代碼 : 1350-UI-01
 * 頁面說明 : 控制信號清單列表頁面
 * @module modules/control-code/components/ControlCodePage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';
import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class ControlCodePage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchControlCodeStr: '',
            searchControlType: '',
        };
        this.setSearchControlCodeStr = this.setSearchControlCodeStr.bind(this);
        this.setSearchControlType = this.setSearchControlType.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareControlCodeTable = this.prepareControlCodeTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchControlCodeStr(searchControlCodeStr) {
        this.setState({ searchControlCodeStr });
    }

    setSearchControlType(searchControlType) {
        this.setState({ searchControlType });
    }


    prepareControlCodeTable = () => {
        const { controlCodeList } = this.props;

        // 定義資料內容
        const dataSet = controlCodeList.map((controlCode) => {
            return [
                controlCode.controlCode,
                controlCode.controlType,
                controlCode.floorNum,
                controlCode.controlMessage,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-ctrlCode-' + meta.row;
                    return `
                        <div class="form-check">
                            <input class="form-check-input item-cks-ctrlCode" type="checkbox" value="" id="${checkboxId}" name="cks" />
                            <label class="form-check-label" for="${checkboxId}"></label>
                        </div>
                    `;
                },
                width: '5%',
            },
            { title: '信號代碼', className: 'dt-center', data: 0 },
            { 
                title: '信號類型',
                className: 'dt-center',
                data: 1,
                render: function (data, type, row) {
                    let controlType = '';
                    switch (data) {
                        case 'HU':
                            controlType = '乘場叫車上樓';
                            break;
                        case 'HD':
                            controlType = '乘場叫車下樓';
                            break;
                        case 'C':
                            controlType = '車廂控制';
                            break;
                        case 'DU':
                            controlType = '車廂行進方向(上)';
                            break;
                        case 'DD':
                            controlType = '車廂行進方向(下)';
                            break;
                        case 'CL':
                            controlType = '車廂所在樓層';
                            break;
                        case 'DC':
                            controlType = '關門';
                            break;
                        case 'DO':
                            controlType = '開門';
                            break;
                        default:
                            controlType = '';
                            break;
                    }
                    return controlType;
                },
            },
            { title: '控制樓層', className: 'dt-center', data: 2 },
            {
                title: '顯示訊息',
                className: 'dt-center',
                data: 3,
                render: function (data, type, row) {
                    // Replace "#TO#" with Bootstrap right arrow icon
                    if (data.includes('#TO#')) {
                        data = data.replace('#TO#', '<i class="bi bi-caret-right-fill" style="color: blue;"></i>')
                    }
                    // Replace "#UP#" with Bootstrap up arrow icon
                    if (data.includes('#UP#')) {
                        data = data.replace('#UP#', '<i class="bi bi-caret-up-fill" style="color: red;"></i>')
                    }
                    // Replace "#DN#" with Bootstrap up arrow icon
                    if (data.includes('#DN#')) {
                        data = data.replace('#DN#', '<i class="bi bi-caret-down-fill" style="color: green;"></i>')
                    }
                    // Replace "%s" with '控制樓層' value
                    if (data.includes('%s')) {
                        data = data.replace('%s', row[2]);
                    }
                    return data
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let editId = 'edit-ctrlCode-' + meta.row;
                    let deleId = 'dele-ctrlCode-' + meta.row;
                    let updateButton = this.checkPermission(ModuleEnums.CONTROL_CODE, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-edit"></use>
                            </svg>
                            修改
                        </button>` : '';
                    let deleteButton = this.checkPermission(ModuleEnums.CONTROL_CODE, AccessModeEnums.DELETE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
                            刪除
                        </button>` : '';
                    return `
                        <div class="btn-group" role="group" aria-label="">
                            ${updateButton}
                            ${deleteButton}
                        </div>`;
                },
            }
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 1,
            dir: 'asc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__controlCodeList')) {
            $('#datatable__controlCodeList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__controlCodeList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 檢查權限
        this.checkPermission(ModuleEnums.CONTROL_CODE, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needControlCodeLoad, setNeedControlCodeLoad, controlCodeList } = this.props;

        if (needControlCodeLoad && 
            needControlCodeLoad !== prevProps.needControlCodeLoad) {
            if (controlCodeList.length > 0) {
                this.prepareControlCodeTable();
            }
            setNeedControlCodeLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const controlCode = searchForm.get('searchControlCodeInput');
        const controlType = searchForm.get('searchControlTypeSelection')? searchForm.get('searchControlTypeSelection') : '';
        this.props.setSearchControlCode(controlCode, controlType);
        this.props.fetchControlCodeList(controlCode, controlType).then(() => {
            // Get data and redraw datatable
            this.prepareControlCodeTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                if (button && button.id.startsWith('edit-ctrlCode-')) {
                    this.props.onEditControlCode(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('dele-ctrlCode-')) {
                    const delControlCode = this.props.controlCodeList[parseInt(button.id.split('-')[2])];
                    const controlId = delControlCode.controlId;
                    const controlCode = delControlCode.controlCode;
                    const message = `確定要刪除 [ ${controlCode} ] 控制信號資料嗎？`;
                    this.props.onDeleteControlCode(message, controlId);
                }
            });
        }
    }

    onBatchHandle(mode = AlertModalModeEnums.DELETE) {
        const controlIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-ctrlCode');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const controlId = this.props.controlCodeList[parseInt(checkbox.id.split('-')[2])].controlId;
                controlIds.push(controlId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (controlIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(mode, controlIds);      
    }

    render() {
        const { onNewControlCode } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="系統設定" pageName="控制信號" />
                <h4>控制信號</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchControlCodeInput" className="form-label">信號代碼</label>
                            <input type="text" className="form-control form-control-sm" id="searchControlCodeInput" name="searchControlCodeInput" value={this.state.searchControlCodeStr} onChange={e => this.setSearchControlCodeStr(e.target.value)} />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchControlTypeSelection" className="form-label">信號類型</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchControlTypeSelection"
                                name="searchControlTypeSelection"
                                value={this.state.searchControlType}
                                onChange={e => this.setSearchControlType(e.target.value)}>
                                <option value="">全部</option>
                                <option key="1" value="HU">乘場叫車上樓</option>
                                <option key="2" value="HD">乘場叫車下樓</option>
                                <option key="3" value="C">車廂控制</option>
                                <option key="4" value="DU">車廂行進方向(上)</option>
                                <option key="5" value="DD">車廂行進方向(下)</option>
                                <option key="6" value="CL">車廂所在樓層</option>
                                <option key="7" value="DC">關門</option>
                                <option key="8" value="DO">開門</option>
                            </select>
                        </div>
                        <div>
                            <button 
                                className="btn btn-primary" 
                                type="submit"
                                aria-label="搜尋"
                            >
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        {this.checkPermission(ModuleEnums.CONTROL_CODE, AccessModeEnums.DELETE) && (
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="刪除" id="btnBatchDelete" onClick={() => this.onBatchHandle(AlertModalModeEnums.DELETE)}>
                                    <svg className="btn__icon me-2" aria-hidden="true">
                                        <use href="#ico-trash"></use>
                                    </svg>
                                    刪除
                                </button>
                        </div>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.CONTROL_CODE, AccessModeEnums.CREATE) && (
                        <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalControlCodeBtnNew" onClick={onNewControlCode}>
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-plus"></use>
                            </svg>
                            新增
                        </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__controlCodeList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

ControlCodePage.propTypes = {
};

ControlCodePage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlCodePage);